// extracted by mini-css-extract-plugin
export default {"recos":"uma-z","productCardOverride":"vma-z","rowHasBadge":"wma-z"};